import './App.css';
import React from 'react'
import Board from './Components/Board'


function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
